import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-473c1b25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "tabs-container__tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tabs-container__page" }

import { Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTabs',
  props: {
    tabs: {}
  },
  setup(__props: any) {

const props = __props;



const activeTab: Ref<string> = ref(props.tabs[0]?.name ?? '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tab.name,
          class: _normalizeClass(`tabs-container__tabs_tab ${
					activeTab.value === tab.name
						? 'tabs-container__tabs_tab-active'
						: ''
				}`),
          onClick: ($event: any) => (activeTab.value = tab.name)
        }, [
          _createElementVNode("p", null, _toDisplayString(tab.title), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: tab.name
        }, [
          (activeTab.value === tab.name)
            ? _renderSlot(_ctx.$slots, tab.name, { key: 0 })
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})